import chroma from "chroma-js";
import moment from "moment/moment";

export function opacityFromDate(date, now, fullMonth, request) {
    // console.log(moment(date).format() + " -> " + now.format());

    if(request) return 0.8;
    if(fullMonth && moment(date).isSame(now, "month"))return 1;

    let diff = Math.abs(moment(date).diff(now, "months", true));
    let opacity = Math.min(1, Math.max(0.3, (1 - diff) / 2));
    return opacity;
}


export function formatHoursAsString(totalMinutes) {
    if (!totalMinutes) return "";

    const hours = totalMinutes / 60;
    const fullHours = Math.floor(hours);
    const minutes = parseInt(Math.max(0, totalMinutes - fullHours * 60), 10);
    return fullHours + " hr " + minutes + " min";
}

const priceFormatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
});

const numberFormatter = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 2
});


export const climateImpactScale = chroma.scale(['green', 'red']);
export const transfersScale = chroma.scale(['green', 'red']);

export function formatPriceAsString(price, withoutEuroSign) {
    let formattedPrice = priceFormatter.format(price);
    if (withoutEuroSign) formattedPrice = formattedPrice.substring(1);
    return formattedPrice;
}

export function formatCo2(co2) {
    if (co2 < 1) {
        return "<1";
        // return parseInt(co2 * 10, 10) / 10;
    } else {
        return parseInt(co2, 10);
    }
}

export function formatDistance(distance) {
    if (distance < 1000) {
        return Math.round(distance) + " m"
    } else {
        return numberFormatter.format(distance / 1000) + " km"
    }
}


export function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}


// WEBPACK FOOTER //
// ./src/utils.js